/* eslint-disable import/prefer-default-export */
import { api } from './http';

export const todas = filters => {
  const params = new URLSearchParams();
  if (filters) {
    if (filters.status) {
      params.append('status', filters.status);
    }
    if (filters.period) {
      if (filters.period.start) {
        params.append('inicio', filters.period.start.toISOString());
      }
      if (filters.period.end) {
        params.append('fim', filters.period.end.toISOString());
      }
    }
    if (filters.page) params.append('pagina', filters.page);
    if (filters.perPage) params.append('por_pagina', filters.perPage);
    if (filters.contextFilter) params.append('contextFilter', filters.contextFilter);
  }
  const queryString = params.toString();
  return api.get(`/validacao-empresa${queryString ? `?${queryString}` : ''}`);
};

export const obter = empresaPendenteId => api.get(`/validacao-empresa/${empresaPendenteId}`);
export const validacoesEmpresa = empresaId => api.get(`/validacao-empresa/validacoes/${empresaId}`);
export const solicitarValidacao = empresaId =>
  api.get(`/validacao-empresa/${empresaId}/solicitar-validacao`);
export const atualizar = (empresaPendenteId, data) =>
  api.patch(`/validacao-empresa/${empresaPendenteId}`, data);

export const fetchLastValidation = companyId =>
  api.get(`/validacao-empresa/${companyId}/last-validation`);
